import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import SearchAndFilter from '../SearchAndFilter'
import Pagination from '../Pagination'

import LexiconLetter from './Letter'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;

  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(80)};
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`
export const _SearchAndFilter = styled(SearchAndFilter)``
export const List = styled.ol``
export const _LexiconLetter = styled(LexiconLetter)``
export const _Pagination = styled(Pagination)`
  @media ${mq(sizes.mobile)} {
    width: min-content;
    margin-inline: auto;
  }
`
